import React, { DetailedHTMLProps, HTMLAttributes, ReactElement, useMemo } from 'react';

import { makeClassNames } from '../../../utils/styles';

type RenderFunction<T extends object> = (data: T) => ReactElement;

export type FieldDefinition<T extends object> =
  | keyof T
  | {
      prop: keyof T;
      render?: RenderFunction<T>;
    };

interface FieldProps<T extends object> extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  data: T;
  field: FieldDefinition<T>;
  className?: string;
}
function Field<T extends object>({ data, field, className, ...props }: FieldProps<T>) {
  const name = useMemo<string>(() => (typeof field === 'object' ? String(field.prop) : String(field)), [field]);
  const renderCallback = useMemo<RenderFunction<T> | undefined>(
    () => (typeof field === 'object' ? field.render : undefined),
    [field]
  );

  const cn = useMemo<{ item: string }>(
    () => makeClassNames({ item: `field-name-${name}` }) as { item: string },
    [name]
  );

  return (
    <div className={`${className} ${cn.item}`} {...props}>
      {renderCallback?.(data) ?? data?.[name as keyof T]}
    </div>
  );
}

export default Field;
